import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Si è verificato un errore. Riprova.") {
  const d = e?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtScore = (n) => Number(n || 0).toFixed(1).replace(".", ",");
export const fmtEuro = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const REVIEW_STATUS = { pending: "In attesa", approved: "Pubblicata", rejected: "Rifiutata" };
export const INVITE_STATUS = { scheduled: "Programmato", sent: "Inviato", completed: "Recensito", failed: "Errore" };
export const CLAIM_STATUS = { aperta: "Aperta", in_gestione: "In gestione", risolta: "Risolta", respinta: "Respinta" };
export const CLAIM_REASONS = {
  non_ricevuto: "Prodotto non ricevuto",
  non_conforme: "Non conforme alla descrizione",
  danneggiato: "Danneggiato o difettoso",
  rimborso: "Reso effettuato, rimborso non ricevuto",
  altro: "Altro problema con l'ordine",
};
